import './App.scss';
import { ThemeProvider } from '@mui/material/styles';
import { customTheme } from './theme';
import AppContent from './AppContent';

function App() {
  return (
    <ThemeProvider theme={customTheme}>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;


